import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "catalyst/button";
import { Alert, AlertActions, AlertDescription, AlertTitle, } from "catalyst/alert";
import { Text, TextLink } from "catalyst/text";
import { useCallback, useEffect, useRef, useState } from "react";
import { mockApi, mockApiChallengeV2, apiSignup, urlApiChallengeV2, } from "../lib/api.js";
import Spinner from "../components/Spinner.js";
import { useLocation, useSearchParams } from "wouter";
import { bumpEpoch, getJson, isLocalReturnTo } from "../lib/util.js";
import { withReturnTo } from "./Login.js";
async function solveChallengesInWorker(worker, challenges, difficultyBits) {
    return await new Promise((resolve, reject) => {
        const cleanup = () => {
            worker.onmessage = null;
            worker.onerror = null;
            worker.onmessageerror = null;
        };
        worker.onmessage = (event) => {
            const data = event.data;
            if (typeof data !== "object" || data === null)
                return;
            const type = data.type;
            if (type === "solved") {
                cleanup();
                resolve(data.nonces);
            }
            else if (type === "error") {
                cleanup();
                reject(new Error(String(data.message)));
            }
        };
        worker.onerror = (event) => {
            cleanup();
            reject(new Error(event.message));
        };
        worker.onmessageerror = () => {
            cleanup();
            reject(new Error("Worker message error"));
        };
        worker.postMessage({
            type: "solve",
            challenges,
            difficulty: difficultyBits,
        });
    });
}
const Register = () => {
    const [isWorking, setIsWorking] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const powWorkerRef = useRef(null);
    const [, navigate] = useLocation();
    const [searchParams] = useSearchParams();
    const returnTo = searchParams.get("return_to");
    useEffect(() => {
        return () => {
            powWorkerRef.current?.terminate();
            powWorkerRef.current = null;
        };
    }, []);
    const startSignup = useCallback(async () => {
        if (isWorking)
            return;
        setIsWorking(true);
        setErrorMsg(null);
        try {
            powWorkerRef.current?.terminate();
            powWorkerRef.current = new Worker("/modules/entrypoints/pow-worker.js", {
                type: "module",
            });
            const challenge = mockApi
                ? mockApiChallengeV2
                : await getJson(urlApiChallengeV2);
            const worker = powWorkerRef.current;
            if (!worker) {
                throw new Error("Worker failed to start");
            }
            const nonces = await solveChallengesInWorker(worker, challenge.challenges, challenge.difficulty);
            await apiSignup({ nonces });
            bumpEpoch();
            if (!returnTo || isLocalReturnTo(returnTo, window.location.origin)) {
                navigate("/?first-enter", { replace: true });
            }
        }
        catch (err) {
            console.error(err);
            setErrorMsg(err instanceof Error ? err.message : String(err));
            setIsWorking(false);
        }
        finally {
            powWorkerRef.current?.terminate();
            powWorkerRef.current = null;
        }
    }, [isWorking, returnTo]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "grid gap-[18px]", children: [_jsx("div", { children: _jsxs(Button, { className: "w-full items-center", disabled: isWorking, onClick: startSignup, children: [isWorking && _jsx(Spinner, {}), isWorking ? "Создаем аккаунт..." : "Создать новый аккаунт"] }) }), _jsx("div", { children: _jsxs(Text, { children: ["\u041E\u0434\u0438\u043D \u043A\u043B\u0438\u043A, \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u0444\u043E\u0440\u043C. \u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442?", " ", _jsx(TextLink, { href: withReturnTo("/login", returnTo), children: "\u0412\u0445\u043E\u0434" })] }) })] }), _jsxs(Alert, { open: errorMsg !== null, onClose: (open) => {
                    if (!open)
                        setErrorMsg(null);
                }, children: [_jsx(AlertTitle, { children: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442" }), _jsx(AlertDescription, { children: errorMsg }), _jsx(AlertActions, { children: _jsx(Button, { onClick: () => setErrorMsg(null), children: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E" }) })] })] }));
};
export default Register;
